import Swiper from 'swiper';
import { Grid, Navigation } from 'swiper/modules';

export default function setProductSlider() {
  const sections = document.querySelectorAll('[data-products-slider]');

  sections.forEach((section) => {
    const swiperEl = section.querySelector('.swiper');
    const next = section.querySelector('.swiper-button-next');
    const prev = section.querySelector('.swiper-button-prev');

    if (swiperEl) {
      const carousel = new Swiper(swiperEl, {
        modules: [Grid, Navigation],
        slidesPerView: 1.8,
        slidesPerGroup: 1,
        spaceBetween: 16,
        rewind: true,
        watchOverflow: true,
        speed: 1000,
        grid: {
          rows: 1,
          fill: 'row',
        },
        navigation: {
          nextEl: next,
          prevEl: prev,
        },
        breakpoints: {
          992: {
            slidesPerView: 2,
            slidesPerGroup: 2,
            spaceBetween: 40,
            grid: {
              rows: 2,
              fill: 'row',
            },
          },
        },
      });
    }
  });
}
